angular.module('userLeaveReasons', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);


// WEBPACK FOOTER //
// ./src/app/user-leave-reasons/user-leave-reasons.module.js